import React, { useMemo, useCallback } from 'react';
import { Typography } from '@mui/material';
import { Editable, withReact, Slate } from 'slate-react';
import { createEditor } from 'slate';

export const emptyValue = [{ type: 'paragraph', children: [{ text: '' }] }];

export const Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    // eslint-disable-next-line no-param-reassign
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    // eslint-disable-next-line no-param-reassign
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    // eslint-disable-next-line no-param-reassign
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    // eslint-disable-next-line no-param-reassign
    children = <u>{children}</u>;
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <span {...attributes}>{children}</span>;
};

const headerStyles = {
  fontWeight: 'bold',
  fontSize: '20px',
};

export const Element = ({ attributes, children, element }) => {
  switch (element.type) {
    case 'bulleted-list':
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <ul {...attributes}>{children}</ul>;
    case 'heading-one':
      return (
        <Typography component="h1" style={headerStyles}>
          {children}
        </Typography>
      );
    case 'heading-two':
      return (
        <Typography component="h2" style={headerStyles}>
          {children}
        </Typography>
      );
    case 'heading-three':
      return (
        <Typography component="h3" style={headerStyles}>
          {children}
        </Typography>
      );
    case 'heading-four':
      return (
        <Typography component="h4" style={headerStyles}>
          {children}
        </Typography>
      );
    case 'heading-five':
      return (
        <Typography component="h5" style={headerStyles}>
          {children}
        </Typography>
      );
    case 'heading-six':
      return (
        <Typography component="h6" style={headerStyles}>
          {children}
        </Typography>
      );
    case 'list-item':
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <li {...attributes}>{children}</li>;
    case 'numbered-list':
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <ol {...attributes}>{children}</ol>;
    case 'paragraph':
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Typography variant="body1" component="p" {...attributes}>
          {children}
        </Typography>
      );
    default:
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <Typography {...attributes}>{children}</Typography>;
  }
};

export const SlateDocument = ({ source }) => {
  const editor = useMemo(() => withReact(createEditor()), []);
  // eslint-disable-next-line react/jsx-props-no-spreading
  const renderElement = useCallback((props) => <Element {...props} />, []);
  // eslint-disable-next-line react/jsx-props-no-spreading
  const renderLeaf = useCallback((props) => <Leaf {...props} />, []);

  return (
    <Slate editor={editor} value={source}>
      <Editable
        readOnly
        renderElement={renderElement}
        renderLeaf={renderLeaf}
        style={{
          wordBreak: 'break-word',
        }}
      />
    </Slate>
  );
};

// eslint-enable react/jsx-props-no-spreading
export default SlateDocument;
